import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, CourseEntity, StudentCourseEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../models/course-progress-variable-context.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { SchoolRepositoryService } from "../../schools/services/school-repository.service";
import { CourseRepositoryService } from "../services/course-repository.service";

@DwAction({
    keyName: 'course-recreate-endorsements',
    display: 'Course - Recreate Endorsements',
    actionType: DwActionType.formAction,
    parentItemName: AppMetaDataItemNames.Course,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Recreate Endorsement PDFs',
        iconClass: 'fa fa-book',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Recreates endorsement PDFs for all students that have been endorsed'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.contentAdmin,
        requireCanUpdate: true
    },
    defaultConfirmConfig :{
        showDialogConfig: true,
        showConfirmDialog: true,
        message: 'Are you sure?  This will recreate endorsement PDFs for all students that have been endorsed!',
        title: 'Recreate Endorsement PDFs'
    }
})
@Injectable()
export class RecreateEndorsementsActionService implements DwMdFormActionHandler {
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private courseRespositoryService: CourseRepositoryService,
        private dwEventService: DwEventService
    ) {
        
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const result: DwActionResult = {
            success: false,
            
        };
        const course = actionState.formApi.getFormData<CourseEntity>();

        if (!course.CourseId) {
            result.cancelled = true;
            return of(result);
        }

        return this.courseRespositoryService.recreateEndorsements(course.CourseId)
            .pipe(map((recreateResult) => {
                const result: DwActionResult = {
                    success: recreateResult.EndorsementsCreated  > 0,
                };

                result.message = `${recreateResult.EndorsementsCreated} Endorsement PDFs have been recreated.`;

                if (recreateResult.EndoresementsFailed > 0) {
                    result.message += ` However, ${recreateResult.EndoresementsFailed} endorsements failed to be recreated.`;
                }
        
                return result;
            }));
    }
}